/* eslint-disable @reatom/unit-naming-rule */

import { match } from 'ts-pattern'

import { Result, Array } from '@blade/std-lib'
import { reatomDataTable } from '@root/shared/ui-kit'

import * as UserProfileHoldingsWalletAsset from '../model/user-profile-holdings-wallet-asset'
import { holdingsAssetsTableColumns } from '../ui/holdings-assets-table/holdings-assets-table-columns'

import type { TableData } from '@root/shared/ui-kit'

export const reatomUserProfileHoldingsAssetsTable = ({
  assets,
}: {
  assets: ReadonlyArray<UserProfileHoldingsWalletAsset.UserProfileHoldingsWalletAsset>
}) => {
  const model = reatomDataTable({
    name: 'user-profile-holdings-assets-table',
    columns: holdingsAssetsTableColumns,
    getId: (x) => x.currency.address,

    loadItems: async (ctx, { sorting }) => {
      const cmp = match(sorting)
        .with({ sortColumn: 'balance' }, ({ sortDirection }) =>
          sortDirection === 'asc'
            ? UserProfileHoldingsWalletAsset.cmpByBalanceUsdAsc
            : UserProfileHoldingsWalletAsset.cmpByBalanceUsdDesc,
        )
        .otherwise(() => undefined)

      const assetsSorted = cmp ? Array.sort(cmp)(assets) : assets

      const data: TableData<UserProfileHoldingsWalletAsset.UserProfileHoldingsWalletAsset> =
        {
          data: [...assetsSorted],
          hasNext: false,
        }
      return Result.succeed(data)
    },
  })

  return model
}
